'use client';
import React, { useState, useEffect } from 'react';
import Hero from '@/app/services/[Pages]/hero';
import { notFound } from 'next/navigation';
import Homep from '@/app/componenets/Homep';
import Content from '@/app/services/[Pages]/content';
import THirdSlider from '@/app/services/[Pages]/thirdSlider';
import BlackCar from '@/app/services/[Pages]/blackcar';
import Distination from '@/app/services/[Pages]/distination';
import LimoService from '@/app/services/[Pages]/limoService';
import MainData from '@/app/data/MainState';
import TawkTo from '../../componenets/Tawko';
import Navbar from '@/app/componenets/Navbar';
import Footer from '@/app/componenets/Footer';
function page({ params }) {
  // console.log(MainData, params, "hellllllll");
  const [image, setImage] = useState('');
  const [title, setTitle] = useState('');
  const [subtitle, setSubtitle] = useState('');

  const mapping = MainData?.find((p) => p?.link === params.Pages);
  // console.log(mapping, "mapping");

  if (!mapping) {
    notFound(); // Ye Next.js ko 404 page dikhaane ke liye bolta hai
  }
  useEffect(() => {
    if (mapping) {
      const data = mapping?.data[0];
      setImage(data.hero_img);
      setTitle(data.title);
      setSubtitle(data.subtitle);
    }
  }, [mapping]);

  console.log(image, 'iiiii');
  return (
    <div>
      <title>
        {mapping?.data?.length > 0
          ? mapping.data[6].metaTitle
          : 'Prestige Ride | First-Class Black Car & Chauffeur Services'}
      </title>
      <meta
        name="description"
        content={
          mapping?.data?.length > 0
            ? mapping.data[6].metaDescription
            : 'Prestige Ride offers luxury car transportation services along with well-trained chauffeurs and vehicles to make your next trip unforgettable.'
        }
      />

      {/* OG Tags */}
      <meta
        property="og:url"
        content={
          mapping?.data?.length > 0
            ? mapping.data[6].Link
            : 'https://www.prestigeride.com'
        }
      />
      <meta property="og:type" content="website" />
      <meta
        property="og:title"
        content={
          mapping?.data?.length > 0
            ? mapping.data[6].metaTitle
            : 'Prestige Ride | First-Class Black Car & Chauffeur Services'
        }
      />
      <meta
        property="og:description"
        content={
          mapping?.data?.length > 0
            ? mapping.data[6].metaDescription
            : 'Prestige Ride offers luxury car transportation services along with well-trained chauffeurs and vehicles to make your next trip unforgettable.'
        }
      />
      <meta
        property="og:image"
        content="https://www.prestigeride.com/updated-home/twitterCArd.jpg"
      />

      {/* Twitter Tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta property="twitter:domain" content="prestigeride.com" />
      <meta
        property="twitter:url"
        content={
          mapping?.data?.length > 0
            ? mapping.data[6].Link
            : 'https://www.prestigeride.com'
        }
      />
      <meta
        name="twitter:title"
        content={
          mapping?.data?.length > 0
            ? mapping.data[6].metaTitle
            : 'Prestige Ride | First-Class Black Car & Chauffeur Services'
        }
      />
      <meta
        name="twitter:description"
        content={
          mapping?.data?.length > 0
            ? mapping.data[6].metaDescription
            : 'Prestige Ride offers luxury car transportation services along with well-trained chauffeurs and vehicles to make your next trip unforgettable.'
        }
      />
      <meta
        name="twitter:image"
        content="https://www.prestigeride.com/updated-home/twitterCArd.jpg"
      />

      <meta name="robots" content="index, follow" />
      <meta
        name="keywords"
        content={mapping?.data?.length > 0 ? mapping.data[6].metaKeywords : ''}
      />
      <link
        rel="canonical"
        href={mapping?.data?.length > 0 ? mapping.data[6].Link : ''}
      />

      {/* <Try/> */}
      <TawkTo />
      <Navbar />
      <Homep image={image} title={title} subtitle={subtitle} />
      {/* <Hero Mydata={mapping?.data} /> */}
      <Content Mydata={mapping?.data} />
      <THirdSlider Mydata={mapping?.data} />
      <BlackCar Mydata={mapping?.data} />
      <Distination Mydata={mapping?.data} />
      <LimoService Mydata={mapping?.data} />
      <Footer />
      {/* <Book/> */}
      {/* <Jfk/> */}
      {/* <LastSlider/> */}
      {/* <InnerText/> */}
    </div>
  );
}

export default page;
